// extracted by mini-css-extract-plugin
export default {"students":"students-Lycma","body":"body-mCpAP","bodyTitle":"bodyTitle-iCflq","groups":"groups-xvPoW","loader":"loader-SQciV"};